@let menuItems = menuItems$ | async;
@if (hasAccess() && menuItems && menuItems.length > 0) {
  <nav>
    <p-menubar
      [model]="menuItems"
      styleClass="swd-menubar"></p-menubar>
  </nav>
}
